/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type Tag_Rule_Entity_Type_Enum =
  | 'BASE_UNIT'
  | 'BUYER'
  | 'SUPPLIER';

export type TagRulesQueryVariables = Exact<{
  entity: Types.Tag_Rule_Entity_Type_Enum;
}>;


export type TagRulesQuery = { tag_rule: Array<{ rule: { [key: string]: any } | null, tag_type: Types.Social_Tag_Type_Enum, entity_type: Types.Tag_Rule_Entity_Type_Enum }> };


export const TagRulesDocument = /*#__PURE__*/ gql`
    query TagRules($entity: tag_rule_entity_type_enum!) {
  tag_rule(where: {entity_type: {_eq: $entity}}) {
    rule
    tag_type
    entity_type
  }
}
    `;

/**
 * __useTagRulesQuery__
 *
 * To run a query within a React component, call `useTagRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagRulesQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useTagRulesQuery(baseOptions: Apollo.QueryHookOptions<TagRulesQuery, TagRulesQueryVariables> & ({ variables: TagRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagRulesQuery, TagRulesQueryVariables>(TagRulesDocument, options);
      }
export function useTagRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagRulesQuery, TagRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagRulesQuery, TagRulesQueryVariables>(TagRulesDocument, options);
        }
// @ts-ignore
export function useTagRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagRulesQuery, TagRulesQueryVariables>): Apollo.UseSuspenseQueryResult<TagRulesQuery, TagRulesQueryVariables>;
export function useTagRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagRulesQuery, TagRulesQueryVariables>): Apollo.UseSuspenseQueryResult<TagRulesQuery | undefined, TagRulesQueryVariables>;
export function useTagRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagRulesQuery, TagRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagRulesQuery, TagRulesQueryVariables>(TagRulesDocument, options);
        }
export type TagRulesQueryHookResult = ReturnType<typeof useTagRulesQuery>;
export type TagRulesLazyQueryHookResult = ReturnType<typeof useTagRulesLazyQuery>;
export type TagRulesSuspenseQueryHookResult = ReturnType<typeof useTagRulesSuspenseQuery>;
export type TagRulesQueryResult = Apollo.QueryResult<TagRulesQuery, TagRulesQueryVariables>;